import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

export const Root = styled.div`
  font-size: 14px;
  ${media.M`
    -ms-grid-column: 1;
    grid-column: 1;
  `}
`;

export const Header = styled.h2`
  margin-top: 0;
  margin-bottom: 8px;

  font-weight: 700;
  font-size: 20px;
`;

export const Label = styled.div`
  padding: 8px 16px;
  border: 1px solid ${COLORS.NEUTRAL_STROKE};
  border-bottom: 0;

  &:last-child {
    border-bottom: 1px solid ${COLORS.NEUTRAL_STROKE};
  }

  & > * {
    line-height: 20px;
  }

  &:first-of-type {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-of-type {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const Value = styled.span`
  font-size: 14px;
`;

export const Key = styled.h3`
  font-size: 16px;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 10px;
  color: ${COLORS.NEUTRAL_DISABLED};
`;
